import { Flex } from "antd";
import { Text } from "components/Text";
import { Tag } from "components/Tag";
import { AppointmentTypeModel } from "models/AppointmentTypeModel/AppointmentType.model";
import { JSX } from "react";
import spacing from "theme/spacing.module.scss";

type Props =  {
  appointmentTypeList: AppointmentTypeModel[];
}

export type AppointmentTypeOptionProps = {
  value: string;
  label: JSX.Element;
  price: string;
  priceFrom: string;
  priceTo: string;
  duration: string;
  durationFrom: string;
  durationTo: string;
  formattedPrice: string;
  formattedDuration: string;
  description?: string;
  labelString: string;
}

export const getAppointmentTypeOptions = ({ appointmentTypeList }: Props): AppointmentTypeOptionProps[] => {
  return appointmentTypeList?.map((type) => ({
    value: type.getTypeId(),
    label: (
      <Flex vertical gap={spacing.spacingXS} wrap>
        <Text $textVariant="pSMBold">{type.getTypeName()}</Text>
          {type.getIsAssigned() && (
              <Tag
               text={"wg specjalisty"}
               background={"primaryPurple100"}
               color={"primaryPurple600"}
              />
          )}
        <Flex gap={spacing.spacingSM} justify="space-between">
          <Text $textVariant="label">Cena: {type.getFormattedTypePriceRange()} zł</Text>
          <Text $textVariant="label">Czas trwania: {type.getFormattedTypeDurationRange()}</Text>
        </Flex>
      </Flex>
    ),
    labelString: type.getTypeName(),
    price: type.getTypePriceFrom(),
    priceFrom: type.getTypePriceFrom(),
    priceTo: type.getTypePriceTo(),
    duration: type.getTypeDuration(),
    durationFrom: type.getTypeDurationFrom(),
    durationTo: type.getTypeDurationTo(),
    formattedPrice: type.getFormattedTypePriceRange(),
    formattedDuration: type.getFormattedTypeDurationRange(),
    description: type.getTypeDescription(),
  }));
};
